import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Link,
} from "@material-ui/core";
import React from "react";
import { MODULE_NAME } from "../../moduleName";

export const SuccessDialog: React.FC = () => {
  return (
    <Dialog maxWidth="sm" fullWidth open={true}>
      <DialogTitle data-test="svr-complete-dialog-title">
        Event Notification Saved &amp; Sent
      </DialogTitle>
      <DialogContent>
        The Event Notification has been saved and sent to the regulator(s), you
        can review and amend this Event Notification from the "My Inbox" section
        of the Portal.
      </DialogContent>

      <DialogActions>
        <Link className="linkButton" href={`/${MODULE_NAME}`}>
          CLOSE
        </Link>
      </DialogActions>
    </Dialog>
  );
};
